// Withdrawals
import Withdrawal from '../../views/admin/Withdrawals.vue'
import WDeclined from '../../views/admin/withdrawals/Declined.vue'
import WAccepted from '../../views/admin/withdrawals/Accepted.vue'
import WPending from '../../views/admin/withdrawals/Pending.vue'

const withdrawRoute = {
  path: '/hrd12/hrd12/sales',
  component: Withdrawal,
  redirect: '/hrd12/hrd12/withdrawals/processed',
  name: 'Withdrawals',
  meta: {
    title: 'Withdrawals'
  },
  children: [
    {
      path: '/hrd12/hrd12/withdrawals/declined',
      component: WDeclined,
      name: 'DeclinedWithdrawal',
      meta: {
        title: 'Declined Withdrawal'
      }
    },
    {
      path: '/hrd12/hrd12/withdrawals/processed',
      component: WAccepted,
      name: 'AcceptedWithdrawal',
      meta: {
        title: 'Accepted Withdrawal'
      }
    },
    {
      path: '/hrd12/hrd12/withdrawals/pending',
      component: WPending,
      name: 'PendingWithdrawal',
      meta: {
        title: 'Pending Withdrawal'
      }
    }
  ]
}

export default withdrawRoute
